let $headerBtn = $('.header__btn, .header__overlay, .header-in__btn');

$headerBtn.on('click', (e) => {
	let $target = $(e.currentTarget);
	let $header = $target.closest('.header, .header-in');
	let $burger = $header.find('.header__btn, .header-in__btn');
	let $menu = $header.find('.header__mobile');
	let $overlay = $header.find('.header__overlay');

	$header.toggleClass('is-show-mm');
	$burger.toggleClass('is-active');
	$menu.toggleClass('is-active');
	$overlay.fadeToggle(400);
});

